// extracted by mini-css-extract-plugin
module.exports = {"removeRoomBtn":"RelatedRoomsList_removeRoomBtn__1Kpjp"};